import { render, staticRenderFns } from "./OpenAI.vue?vue&type=template&id=8c503d56&scoped=true&"
import script from "./OpenAI.vue?vue&type=script&lang=js&"
export * from "./OpenAI.vue?vue&type=script&lang=js&"
import style0 from "./OpenAI.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OpenAI.vue?vue&type=style&index=1&id=8c503d56&lang=scss&scoped=true&"
import style2 from "./OpenAI.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c503d56",
  null
  
)

export default component.exports